import { PATHS, SORT_ORDER } from 'constants.js'
import { selectLanguageBasedOnBrowserLocale } from 'locale'
import { createSelector } from 'reselect'

import { INDICATORS, PERCENT_INDICATORS, SORT } from './constants'

export const indicator = state => state.rankings.indicator

export const ranking = state => state.rankings.ranking

export const isFetching = state => state.rankings.isFetching

export const areFiltersExpanded = state => state.rankings.areFiltersExpanded

export const isRankingsPath = state => state.router.location.pathname === PATHS.RANKINGS

export const isFetchError = state => state.rankings.isFetchError

export const isFilterCountryModalOpen = state => state.rankings.isFilterCountryModalOpen

export const selectedCountries = state => state.rankings.selectedCountries

export const selectedCountriesCount = state => state.rankings.selectedCountries.length

export const filterCountryInput = state => state.rankings.filterCountryInput

export const sort = state => state.rankings.sort

const getSortBy = ({ activeIndicator, country, sortBy }) => {
  if (sortBy === SORT.TITLE) {
    const countryNameLocale = `countryName${selectLanguageBasedOnBrowserLocale().toUpperCase()}`

    if (country[countryNameLocale]) {
      return countryNameLocale
    }

    if (country.districtManagerId) {
      return 'districtManagerId'
    }

    if (country.regionManagerName) {
      return 'regionManagerName'
    }

    return 'storeName'
  }

  if (sortBy === SORT.INDICATOR) {
    return activeIndicator
  }

  return sortBy
}

export const rankingsCountries = createSelector(
  state => state.rankings.countries,
  sort,
  indicator,
  (countries, { order, sortBy }, activeIndicator) => {
    if (!countries.length) {
      return countries
    }

    return countries.sort((countryA, countryB) => {
      const enhancedSortBy = getSortBy({ activeIndicator, country: countryA, sortBy })
      const isOrderDesc = order === SORT_ORDER.DESC
      const indicatorA = isOrderDesc ? countryA[enhancedSortBy] : countryB[enhancedSortBy]
      const indicatorB = isOrderDesc ? countryB[enhancedSortBy] : countryA[enhancedSortBy]
      const rankA = isOrderDesc ? countryB.rankCurrent : countryA.rankCurrent
      const rankB = isOrderDesc ? countryA.rankCurrent : countryB.rankCurrent

      if (indicatorA < indicatorB) {
        return 1
      }

      if (indicatorA > indicatorB) {
        return -1
      }

      if (rankA < rankB) {
        return 1
      }

      if (rankA > rankB) {
        return -1
      }

      return 0
    })
  },
)

export const usePercentages = state => PERCENT_INDICATORS.includes(indicator(state))

export const isHourlyCountriesIndicator = state =>
  [INDICATORS.COMPANIES_NECOMMERCE, INDICATORS.COMPANIES_ECOMMERCE, INDICATORS.COMPANIES_ECOMMERCE_ORDERS].includes(
    indicator(state),
  )

export const storesRequestConfig = state => {
  const currentIndicator = indicator(state)

  switch (currentIndicator) {
    case INDICATORS.STORES_NECOMMERCE:
      return {
        necoms: true,
        ecoms: false,
      }

    case INDICATORS.STORES_ECOMMERCE:
    case INDICATORS.STORES_ECOMMERCE_ORDERS:
      return {
        necoms: false,
        ecoms: true,
      }

    default:
      return null
  }
}
